export const DIVIDER = 'divider';
export const DROPDOWN = 'dropdown';
export const BUTTON = 'button';
export const LINK = 'link';
export const HUBSPOT_APP_LINK = 'hubspot-app-link';
export const ACTION_LIBRARY_BUTTON = 'action-library-button';